import { ITokenManager } from './types';

/**
 * 创建 Token 管理器
 * @param fullFeature 是否启用完整功能（包括过期时间管理）
 */
export function createTokenManager(fullFeature = true): ITokenManager {
  const manager: ITokenManager = {
    // 获取 access_token
    getAccessToken: () => {
      return localStorage.getItem('access_token');
    },

    // 获取 access_token 过期时间
    getAccessTokenExpires: () => {
      return localStorage.getItem('access_token_expires');
    },

    // 获取 refresh_token
    getRefreshToken: () => {
      return localStorage.getItem('refresh_token');
    },

    // 设置 access_token
    setAccessToken: (token: string) => {
      localStorage.setItem('access_token', token);
    },

    // 设置 access_token 过期时间
    setAccessTokenExpires: (expiresInSeconds: number) => {
      if (fullFeature) {
        const expiresAt = Date.now() + (expiresInSeconds * 1000);
        localStorage.setItem('access_token_expires', expiresAt.toString());
      }
    },

    // 清除 access_token
    clearAccessToken: () => {
      localStorage.removeItem('access_token');
      localStorage.removeItem('access_token_expires');
    },

    // 设置 refresh_token 到 localStorage
    setRefreshToken: (token: string) => {
      localStorage.setItem('refresh_token', token);
    },

    // 设置 refresh_token 过期时间
    setRefreshTokenExpires: (expiresInSeconds: number) => {
      if (fullFeature) {
        const expiresAt = Date.now() + (expiresInSeconds * 1000);
        localStorage.setItem('refresh_token_expires', expiresAt.toString());
      }
    },

    // 获取 refresh_token 过期时间
    getRefreshTokenExpires: () => {
      const expires = localStorage.getItem('refresh_token_expires');
      return expires ? parseInt(expires, 10) : null;
    },

    // 检查 refresh_token 是否过期
    isRefreshTokenExpired: () => {
      if (!fullFeature) {
        return false; // 简化版不检查过期
      }
      const expires = manager.getRefreshTokenExpires();
      if (!expires) {
        return true;
      }
      const isExpired = Date.now() > expires;
      return isExpired;
    },

    // 清除所有 tokens 和用户信息
    clearAllTokensAndUserInfo: () => {
      localStorage.removeItem('access_token');
      localStorage.removeItem('access_token_expires');
      localStorage.removeItem('refresh_token');
      localStorage.removeItem('refresh_token_expires');
      localStorage.removeItem('user_info');
    }
  };

  return manager;
}
